import { StatsCard } from '../../ui/StatsCard/StatsCard';
import { StatsSectionProps } from './StatsSection.types';

export function StatsSection({
  totalSystems,
  complianceData,
  riskData,
}: StatsSectionProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full">
      <div className="w-full sm:w-2/12 2xl:w-3/12">
        <StatsCard title="Total" variant="simple" value={totalSystems} />
      </div>
      <div className="w-full sm:w-4/12 2xl:4/12">
        <StatsCard
          title="Compliance Status"
          variant="breakdown"
          items={[
            { label: 'Compliant', value: complianceData.compliant },
            { label: 'In Progress', value: complianceData.inProgress },
            { label: 'Non Compliant', value: complianceData.nonCompliant },
          ]}
        />
      </div>
      <div className="w-full sm:w-6/12 2xl:5/12">
        <StatsCard
          title="Risk Classification"
          variant="risk"
          items={[
            {
              label: 'Minimal-Risk',
              value: riskData.minimal,
              textColor: 'text-green-700',
            },
            {
              label: 'Limited-Risk',
              value: riskData.limited,
              textColor: 'text-yellow-700',
            },
            {
              label: 'High-Risk',
              value: riskData.high,
              textColor: 'text-orange-700',
            },
            {
              label: 'Prohibited',
              value: riskData.prohibited,
              textColor: 'text-rose-700',
            },
            {
              label: 'Other',
              value: riskData.other,
              textColor: 'text-gray-800',
            },
          ]}
        />
      </div>
    </div>
  );
}
